import { LETTER_WIDTH_PX, LETTER_HEIGHT_PX } from "./pageDimensions";

export const LAYOUT_TEMPLATES = {
  PORTRAIT_THREE_BY_THREE: {
    key: "portrait_3x3",
    name: "Default 3x3 Portrait Grid",
    page: {
      width: LETTER_WIDTH_PX,
      height: LETTER_HEIGHT_PX,
    },
    margins: {
      top: 10,
      bottom: 10,
      left: 10,
      right: 10,
    },
      gutters: {
        horizontal: 5,
        vertical: 5,
      },
      grid: {
        rows: 3,
        columns: 3,
      },
    },
  PORTRAIT_TWO_BY_TWO: {
    key: "portrait_2x2",
    name: "Balanced 2x2 Grid",
    page: {
      width: LETTER_WIDTH_PX,
      height: LETTER_HEIGHT_PX,
    },
    margins: {
      top: 10,
      bottom: 10,
      left: 10,
      right: 10,
    },
    gutters: {
      horizontal: 5,
      vertical: 5,
    },
    grid: {
      rows: 2,
      columns: 2,
    },
  },
  LANDSCAPE_ONE_BY_THREE: {
    key: "landscape_1x3",
    name: "3 x 1 Horizontal Strip",
    page: {
      width: LETTER_HEIGHT_PX,
      height: LETTER_WIDTH_PX,
    },
    margins: {
      top: 10,
      bottom: 10,
      left: 10,
      right: 10,
    },
    gutters: {
      horizontal: 5,
      vertical: 5,
    },
    grid: {
      rows: 1,
      columns: 3,
    },
  },
};

export const layoutTemplateList = Object.values(LAYOUT_TEMPLATES);

export const getRandomLayoutTemplate = () => {
  const templates = layoutTemplateList;
  const index = Math.floor(Math.random() * templates.length);
  return templates[index];
};
